import React, {useState} from 'react';
import classNames from 'classnames';
import {useDispatch, useSelector} from 'react-redux';

import {copy} from 'shared/utils';
import {AptitudeStore} from 'src/types/store';

import IconTooltip from 'shared/components/icon-tooltip';
import Icon from 'shared/components/icon';

import styles from './typography-example.module.scss';
import {flashTooltip} from 'src/redux/aptitude/actions';

interface Props {
  klass: string;
  children: string;
}

const TypographyExample = ({klass, children}: Props) => {
  const dispatch = useDispatch();
  const shouldShowTooltip = useSelector((state: AptitudeStore) => !!state.tooltips[klass]);
  const [showSnippet, setShowSnippet] = useState(false);

  const toggleSnippet = () => setShowSnippet((prev) => !prev);

  const copyIconToClipboard = () => {
    copy(klass);
    dispatch(flashTooltip(klass));
  };

  return (
    <div>
      <div className={styles.header}>
        <span>
          <code className={styles.code}>.</code>
          <code className={styles.code}>{klass}</code>
        </span>
        <div className="controls">
          <button
            className={classNames(styles.codeButton, {[styles.hideIcon]: showSnippet})}
            onClick={toggleSnippet}
          >
            <Icon iconType="code-r" />
          </button>
          <IconTooltip
            iconType="copy-r"
            iconSize={14}
            placement="top"
            onClick={copyIconToClipboard}
            open={shouldShowTooltip}
            className={styles.copyButton}
          >
            Copied!
          </IconTooltip>
        </div>
      </div>
      <span className={styles[klass]}>Micro-Scholarships Made Simple</span>
      {showSnippet && <pre>{children}</pre>}
    </div>
  );
};

export default TypographyExample;
